(function(){
  // ------- helpers -------
  function closestCard(el){
    return el.closest('product-block') || el.closest('[data-product-id]') || el.closest('.product-block') || el.closest('.grid__item');
  }
  function getTray(card){ return card && card.querySelector('[data-tbbc-swatches-tray]'); }
  function getBtn(card){ return card && card.querySelector('[data-tbbc-swatch-toggle]'); }
  function getScroll(tray){ return tray && tray.querySelector('[data-tbbc-swatches-scroll]'); }
  function isOpen(tray){ return tray && !tray.classList.contains('is-collapsed'); }

  function setTrayShadows(tray){
    if (!tray) return;
    var sc = getScroll(tray); if(!sc) return;
    const canScroll = sc.scrollWidth > sc.clientWidth + 1;
    var L = canScroll && sc.scrollLeft > 2;
    var R = canScroll && (sc.scrollWidth - sc.clientWidth - sc.scrollLeft) > 2;
    tray.classList.toggle('has-left', L);
    tray.classList.toggle('has-right', R);
  }

  function openTray(card){
    var tray = getTray(card), btn = getBtn(card);
    if(!tray || !btn) return;
    tray.classList.remove('is-collapsed');
    tray.classList.add('is-opening');
    btn.classList.add('is-hidden');
    btn.setAttribute('aria-expanded', 'true');
    setTimeout(function(){
        if (tray) {
           tray.classList.remove('is-opening');
           setTrayShadows(tray);
           const sc = getScroll(tray);
           if (sc) bindDragEvents(sc);
        }
    }, 200);
  }
  function closeTray(card){
    var tray = getTray(card), btn = getBtn(card);
    if(!tray || !btn) return;
    tray.classList.add('is-collapsed');
    btn.classList.remove('is-hidden');
    btn.setAttribute('aria-expanded', 'false');
    tray.classList.remove('has-left', 'has-right');
    revertCardPreview(card); // Revert preview when tray closes
  }
  function closeAllOpenTrays(){
    document.querySelectorAll('[data-tbbc-swatches-tray]:not(.is-collapsed)').forEach(function(tray){
      closeTray(closestCard(tray));
    });
  }

  // ------- fades on swatch scroll -------
  document.body.addEventListener('scroll', function(e){
    if(!(e.target instanceof Element) || !e.target.matches('[data-tbbc-swatches-scroll]')) return;
    setTrayShadows(e.target.closest('[data-tbbc-swatches-tray]'));
  }, true);

  // ------- arrow paging (left/right) -------
  function pageBy(tray, dir){
    var sc=getScroll(tray); if(!sc) return;
    var step=Math.max(140, Math.round(sc.clientWidth*0.7));
    sc.scrollBy({left: dir*step, behavior:'smooth'});
    setTimeout(function(){ setTrayShadows(tray); }, 300);
  }
  document.body.addEventListener('click', function(e){
    var arrowBtn = e.target.closest('[data-tbbc-scroll-prev], [data-tbbc-scroll-next]');
    if(!arrowBtn) return;
    var isNext = arrowBtn.hasAttribute('data-tbbc-scroll-next');
    var tray = arrowBtn.closest('[data-tbbc-swatches-tray]');
    pageBy(tray, isNext ? 1 : -1);
  });

  // ------- REAL drag-to-scroll (mouse + touch) -------
  let dragMovedFlag = false;
  let isDragging = false;
  let activeScroller = null;
  let isDown = false, startX = 0, startLeft = 0;

  function handleMouseDown(e){
    activeScroller = e.currentTarget;
    isDown=true;
    dragMovedFlag=false;
    isDragging = false;
    startX = (e.touches?e.touches[0].pageX:e.pageX) - activeScroller.offsetLeft;
    startLeft = activeScroller.scrollLeft;
    window.addEventListener('mousemove', handleMouseMove, {passive:false});
    window.addEventListener('mouseup', handleMouseUp, {passive:false});
    window.addEventListener('touchmove', handleMouseMove, {passive:false});
    window.addEventListener('touchend', handleMouseUp, {passive:false});
    if (e.type === 'touchstart' && !e.target.closest('a')) e.preventDefault();
    else if (e.type === 'mousedown' && !e.target.closest('a')) e.preventDefault();
  }
  function handleMouseMove(e){
    if(!isDown || !activeScroller) return;
    e.preventDefault();
    const x = (e.touches?e.touches[0].pageX:e.pageX) - activeScroller.offsetLeft;
    const walk = x - startX;
    if(Math.abs(walk)>5 && !dragMovedFlag) {
      dragMovedFlag=true;
      isDragging = true;
      activeScroller.classList.add('is-dragging');
    }
    if (isDragging) activeScroller.scrollLeft = startLeft - walk;
  }
  function handleMouseUp(e){
    if(!activeScroller) return;
    setTimeout(() => { dragMovedFlag = false; }, 0); // Reset flag *after* potential click handler runs
    isDown=false;
    isDragging = false;
    if (activeScroller) {
        activeScroller.classList.remove('is-dragging');
        setTrayShadows(activeScroller.closest('[data-tbbc-swatches-tray]'));
    }
    window.removeEventListener('mousemove', handleMouseMove);
    window.removeEventListener('mouseup', handleMouseUp);
    window.removeEventListener('touchmove', handleMouseMove);
    window.removeEventListener('touchend', handleMouseUp);
    activeScroller=null;
  }
  function handleWheel(e){
    const el = e.currentTarget;
    if(el.scrollWidth > el.clientWidth && Math.abs(e.deltaY) > Math.abs(e.deltaX)){
      el.scrollLeft += e.deltaY;
      e.preventDefault();
      setTrayShadows(el.closest('[data-tbbc-swatches-tray]'));
    }
  }
  function bindDragEvents(sc) {
      if(!sc || sc._dragBound) return;
      sc.addEventListener('mousedown', handleMouseDown);
      sc.addEventListener('touchstart', handleMouseDown, {passive:false});
      sc.addEventListener('wheel', handleWheel, {passive:false});
      sc._dragBound = true;
  }
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-tbbc-swatches-scroll]').forEach(bindDragEvents);
    document.querySelectorAll('[data-tbbc-swatches-tray]:not(.is-collapsed)').forEach(setTrayShadows);
  });

  // =================================================================
  // START: IMAGE, LINK & TITLE SWAPPING LOGIC
  // =================================================================

  function handleSwatchPreview(swatchEl) {
    var card = closestCard(swatchEl);
    if (!card) return;
    var newImageUrl = swatchEl.dataset.previewImage;
    var newHref = swatchEl.href;
    var newTitle = swatchEl.dataset.productTitle;
    if (!newImageUrl || !newHref || !newTitle) return;

    var imgCont = card.querySelector('.image-cont');
    var titleEl = card.querySelector('.product-block__title');
    if (!imgCont || !titleEl) return;

    // --- Store originals before making changes ---
    if (!titleEl.dataset.originalTitle) titleEl.dataset.originalTitle = titleEl.textContent;
    card.querySelectorAll('a.product-link').forEach(function(link) {
      if (!link.dataset.originalHref) link.dataset.originalHref = link.href;
    });

    // Remove existing preview image FIRST
    var oldPreview = card.querySelector('.tbbc-swatch-preview-image');
    if (oldPreview) oldPreview.remove();

    // Update title
    titleEl.textContent = newTitle;

    // Create and add new preview image
    var previewImg = document.createElement('img');
    previewImg.className = 'tbbc-swatch-preview-image';
    previewImg.src = newImageUrl;
    Object.assign(previewImg.style, {
        position: 'absolute', top: '0', left: '0', width: '100%', height: '100%',
        objectFit: 'cover', zIndex: '5', pointerEvents: 'none', borderRadius: 'inherit'
    });
    imgCont.appendChild(previewImg);

    // Update links AFTER adding image and title
    card.querySelectorAll('a.product-link').forEach(function(link) {
      link.href = newHref;
    });
  }

  function revertCardPreview(card) {
    if (!card) return;
    var oldPreview = card.querySelector('.tbbc-swatch-preview-image');
    if (oldPreview) oldPreview.remove();

    var titleEl = card.querySelector('.product-block__title');
    if (titleEl && titleEl.dataset.originalTitle) {
      titleEl.textContent = titleEl.dataset.originalTitle;
      delete titleEl.dataset.originalTitle;
    }

    card.querySelectorAll('a.product-link').forEach(function(link) {
      if (link.dataset.originalHref) {
        link.href = link.dataset.originalHref;
        delete link.dataset.originalHref;
      }
    });
  }

  // --- Main Click Handler using Event Delegation ---
  document.body.addEventListener('click', function(e) {
    const toggleBtn = e.target.closest('[data-tbbc-swatch-toggle]');
    const swatch = e.target.closest('a.tbbc-swatch');
    const tray = e.target.closest('[data-tbbc-swatches-tray]');
    const clickedCard = closestCard(e.target); // Find the card the click happened on

    // Case 1: Clicked the Toggle Button
    if (toggleBtn) {
      const card = closestCard(toggleBtn); // Should be same as clickedCard
      const currentTray = getTray(card);
      if(!currentTray) return;
      if (!isOpen(currentTray)) {
        closeAllOpenTrays();
        openTray(card);
      } else {
        closeTray(card);
      }
      return; // Handled toggle click
    }

    // Case 2: Clicked a Swatch Link
    if (swatch) {
      // If a drag just happened, prevent the click entirely
      if (dragMovedFlag) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      const isHoverDevice = window.matchMedia('(hover: hover)').matches;
      if (!isHoverDevice) {
        // Mobile (Touch): Prevent navigation FIRST, then handle preview
        e.preventDefault();
        handleSwatchPreview(swatch);
      } else {
         // Desktop: Allow default navigation (no revert needed before nav)
      }
      return; // Handled swatch click (or allowed default on desktop)
    }

    // --- MODIFIED: Case 3: Clicked Somewhere Else ---
    const openTrayEl = document.querySelector('[data-tbbc-swatches-tray]:not(.is-collapsed)');
    if (openTrayEl) {
        const cardOfOpenTray = closestCard(openTrayEl);
        // Close ONLY if the click was outside the card containing the open tray
        if (cardOfOpenTray && !cardOfOpenTray.contains(e.target)) {
            closeTray(cardOfOpenTray);
        }
        // If the click was on the main product link (a.product-link) inside the card
        // with the open tray, we *don't* close the tray here, allowing navigation
        // to the (potentially updated) href.
    }

  }); // Use Bubbling phase (default)

  // --- Desktop Hover: Mouse Over/Out using Event Delegation ---
  document.body.addEventListener('mouseover', function(e) {
    if (window.matchMedia('(hover: none)').matches) return;
    var swatch = e.target.closest('a.tbbc-swatch');
    if (swatch && isOpen(getTray(closestCard(swatch)))) {
        handleSwatchPreview(swatch);
    }
  });
  document.body.addEventListener('mouseout', function(e) {
    if (window.matchMedia('(hover: none)').matches) return;
    var card = closestCard(e.target);
    if (!card) return;
    if (!e.relatedTarget || !card.contains(e.relatedTarget)) {
      revertCardPreview(card);
    }
  });

  // --- Close on Escape Key ---
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeAllOpenTrays();
  });

  // --- Close on Page Scroll ---
  var pageScrollTimer=null,lastY=window.scrollY;
  window.addEventListener('scroll', function(){
    clearTimeout(pageScrollTimer);
    pageScrollTimer=setTimeout(function(){
      if(Math.abs(window.scrollY-lastY)>10) closeAllOpenTrays();
      lastY=window.scrollY;
    },150);
  }, {passive:true});

  // --- Handle Shopify Theme Editor updates & AJAX Pagination ---
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
           const scrollContainers = node.matches('[data-tbbc-swatches-scroll]') ? [node] : node.querySelectorAll('[data-tbbc-swatches-scroll]');
           scrollContainers.forEach(sc => {
               const tray = sc.closest('[data-tbbc-swatches-tray]');
               if (tray && isOpen(tray)) setTrayShadows(tray);
               bindDragEvents(sc);
           });
           const openTrays = node.matches('[data-tbbc-swatches-tray]:not(.is-collapsed)') ? [node] : node.querySelectorAll('[data-tbbc-swatches-tray]:not(.is-collapsed)');
           openTrays.forEach(setTrayShadows);
        }
      });
    });
  });
  const productGrid = document.querySelector('.collection main') || document.querySelector('.product-recommendations') || document.body;
  if (productGrid) {
      observer.observe(productGrid, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', function(event) {
     setTimeout(() => {
        event.target.querySelectorAll('[data-tbbc-swatches-scroll]').forEach(bindDragEvents);
        event.target.querySelectorAll('[data-tbbc-swatches-tray]:not(.is-collapsed)').forEach(setTrayShadows);
     }, 100);
  });

})();